export default {
  namespace: 'down',
  state: {
    data: {
      list: [],
      pagination: {},
    },
    showPage: 'search',
    editEntity: {},
  },

  effects: {
    *onshowPage({ payload, callback }, { call, put }) {
      yield put({
        type: 'showPage',
        showPage: payload.showPage,
        editEntity: payload.editEntity,
      });
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    showPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        editEntity: action.editEntity,
      };
    },
  },
};
